import React from 'react';
import styled from 'styled-components'
import { Link, withRouter } from "react-router-dom"
import { Col, Row, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import Logo from '../../assets/logo-white.svg'
import { isAuthenticated, logout } from '../../auth'
import { AuthContext } from '../../contexts/AuthContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'

const StyledHeader = styled.div`
background-color: "#296ba9";
border-bottom: 5px solid rgba(41, 107, 169, 1);
height: 10vh;
padding:5px;
display: flex;
align-items: center;
z-index: 1;`

const HeaderContainer = styled.div`
    width: 100%;
    padding: 0px 50px;
`;

const LogoutButton = styled.div`
background: none;
border: none;
font-weight: bold;
cursor: pointer;
`

const Header = (props) => {
    return (
        <StyledHeader>
            <HeaderContainer>
                <Row>
                    <Col xs={6} md={9}>
                        <Link to={"/"}>
                            <img className="img-fluid" width="180px" height="auto" src={Logo} alt="Logo MPT" />
                        </Link>
                    </Col>
                </Row>
            </HeaderContainer>
        </StyledHeader>
    )
};

export default withRouter(Header);
